import React from 'react';
import { Box, Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';


const techStatus = [
    { id: 1, value: '1', label: '지원요청', color: 'default' },
    { id: 2, value: '2', label: '지원확인', color: 'info' },
    { id: 3, value: '3', label: '작업계획', color: 'warning' },
    { id: 4, value: '4', label: '완료보고', color: 'error' },
    { id: 5, value: '5', label: '결재중', color: 'secondary' },
    { id: 6, value: '6', label: '결재완료', color: 'success' },
]


const TechReqStatusList = ({ searchGrade, onChangeGrade }) => {
    return (
        <Box className="status-chip-list"
            sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItem: 'center',
                m: 1,
            }}
        >
            {techStatus && techStatus.map((st, index) => (
                <Chip
                    sx={{ mr: 2 }}
                    key={index}
                    icon={<CircleIcon />}
                    label={st.label}
                    variant={st.value === searchGrade ? 'contained' : 'outlined'}
                    color={st.color}
                    onClick={() => onChangeGrade(st.value)}
                />
            ))}
        </Box>
    )
};

export default TechReqStatusList;
